import { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box, Chip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const AtsMoveStageDialog = ({
  open,
  onConfirm,
  onCancel,
  fromStage,
  toStage,
  candidateName,
  isPhaseMove = false,
}) => {
  const { t } = useTranslation();
  const [note, setNote] = useState('');

  const handleConfirm = () => {
    onConfirm(note.trim() || null);
    setNote('');
  };

  const handleCancel = () => {
    onCancel();
    setNote('');
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {isPhaseMove
          ? t('ats.moveDialog.titlePhase')
          : t('ats.moveDialog.titleStage')
        }
      </DialogTitle>
      <DialogContent>

        {/* Resumen del movimiento */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 3 }}>
          {candidateName && (
            <>
              <Typography variant="body2" fontWeight={600}>{candidateName}</Typography>
              <Typography variant="body2" color="text.secondary">→</Typography>
            </>
          )}
          {fromStage && (
            <Chip label={fromStage.name} size="small" variant="outlined" />
          )}
          {fromStage && toStage && (
            <Typography variant="body2" color="text.secondary">→</Typography>
          )}
          {toStage && (
            <Chip
              label={toStage.name}
              size="small"
              sx={{ backgroundColor: '#6A5AF9', color: '#fff' }}
            />
          )}
        </Box>

        {/* Nota opcional */}
        <TextField
          label={t('ats.moveDialog.noteLabel')}
          placeholder={isPhaseMove
            ? t('ats.moveDialog.notePlaceholderPhase')
            : t('ats.moveDialog.notePlaceholder')
          }
          value={note}
          onChange={(e) => setNote(e.target.value)}
          fullWidth
          multiline
          rows={3}
          autoFocus
        />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          {t('ats.moveDialog.noteOptional')}
        </Typography>

      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="inherit">
          {t('cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          sx={{ backgroundColor: '#6A5AF9', '&:hover': { backgroundColor: '#5B4DE8' } }}
        >
          {t('ats.moveDialog.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AtsMoveStageDialog;